import type { Content } from '@radix-ui/react-tooltip'
import { Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip'
import React, { forwardRef } from 'react'

import type { Size, Variant, Width } from '../../../themes/types'
import { StyledArrow, StyledContent } from './NewTooltip.styles'

export type TooltipProps = React.ComponentPropsWithoutRef<typeof Root> & {
  delayDuration?: number
}

const NewTooltip = ({ delayDuration = 50, ...props }: TooltipProps) => (
  <Provider delayDuration={delayDuration}>
    <Root {...props} />
  </Provider>
)

const TooltipTrigger = Trigger

export type TooltipContentProps = React.ComponentPropsWithoutRef<typeof Content> & {
  'data-e2e'?: string
  maxWidth?: Width
  minWidth?: Width
  spacing?: Size
  variant?: Variant
  withArrow?: boolean
}

const TooltipContent = forwardRef<React.ElementRef<typeof Content>, TooltipContentProps>(
  (
    {
      'data-e2e': dataE2e,
      children,
      maxWidth,
      minWidth = '150px',
      sideOffset = 4,
      spacing = 'small',
      variant = 'white',
      withArrow = true,
      ...props
    },
    ref
  ) => (
    <Portal>
      <StyledContent
        $maxWidth={maxWidth}
        $minWidth={minWidth}
        $spacing={spacing}
        $variant={variant}
        data-e2e={dataE2e}
        ref={ref}
        sideOffset={sideOffset}
        {...props}
      >
        {children}

        {withArrow && <StyledArrow $variant={variant} width={11} height={5} />}
      </StyledContent>
    </Portal>
  )
)

export { NewTooltip, TooltipTrigger, TooltipContent }
